import { useBusinessInfo } from '../../lib/Queries';

const ShowTimezoneIfDifferent = ({ timezone, className }) => {
    const { data, isLoading } = useBusinessInfo();
    const businessTimezone = data?.business?.timezone;

    console.log('businessTimezone=', businessTimezone, 'timezone=', timezone)

    if (!businessTimezone || businessTimezone === timezone) {
        return null;
    }

    return <div className={className}>{timezone}</div>;
};

export default ShowTimezoneIfDifferent;
